import React from 'react';

interface Thread {
    id: string;
    title: string;
    preview: string;
    category: string;
    date: Date;
    likes: number;
    retweets: number;
    link: string;
}

interface ThreadCollectionProps {
    threads: Thread[];
    className?: string;
}

const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

export const ThreadCollection: React.FC<ThreadCollectionProps> = ({
    threads,
    className = '',
}) => {
    return (
        <div className={`researcher-threads ${className}`}>
            {threads.map((thread) => (
                <a
                    key={thread.id}
                    href={thread.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="researcher-thread"
                >
                    <div className="researcher-thread-meta">
                        <span className="researcher-thread-tag">{thread.category}</span>
                        <span>{formatDate(thread.date)}</span>
                    </div>

                    <h3 className="researcher-thread-title">{thread.title}</h3>
                    <p className="researcher-thread-preview">{thread.preview}</p>

                    <div className="researcher-thread-stats">
                        <span>❤️ {thread.likes.toLocaleString()}</span>
                        <span>🔄 {thread.retweets.toLocaleString()}</span>
                    </div>
                </a>
            ))}
        </div>
    );
};

export default ThreadCollection;
